var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TypingLoader = function () {
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "conversation__list__item__summary__is-typing u__relative", style: { position: "relative" } }, { children: [_jsx("div", { className: "conversation__is-typing-animation__dot-01" }), _jsx("div", { className: "conversation__is-typing-animation__dot-02" }), _jsx("div", { className: "conversation__is-typing-animation__dot-03" })] })) }));
};
export default TypingLoader;
